module.exports = __webpack_public_path__ + "static/media/city.d530fa5e.svg";